// src/terminal/commands/navigation.js

export function registerNavigationCommands(commandMap, addLines, navigate) {

  const navCommands = {
    archives: '/archives',
    archive: '/archives',
    transcripts: '/archives',
    stories: '/archives',
    story: '/archives',
    read: '/archives',
    '1': '/archives',

    links: '/links',
    link: '/links',
    '2': '/links',

    games: '/games',
    game: '/games',
    play: '/games',
    arcade: '/games',
    '3': '/games',

    feed: '/feed',
    live: '/feed',
    watch: '/feed',
    '4': '/feed',

    subscribe: '/subscribe',
    sub: '/subscribe',
    join: '/subscribe',
    email: '/subscribe',
    '6': '/subscribe',

    admin: '/admin',
    sysop: '/admin',
  };

  Object.entries(navCommands).forEach(([cmd, path]) => {
    commandMap[cmd] = () => {
      navigate(path);
    };
  });

  const aboutHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ═══ ABOUT THE OPHIDIA CLOUD BBS BOARD ═══', color: '#00e5ff' },
      { type: 'blank' },
      { type: 'line', text: '  The Ophidia Cloud BBS board is the main access point to OPU-1.', color: '#cccccc' },
      { type: 'blank' },
    ]);
  };

  commandMap['about'] = aboutHandler;
  commandMap['info'] = aboutHandler;
  commandMap['5'] = aboutHandler;
}